import {Icon, TooltipHost} from '@fluentui/react';
import React from 'react'

 const InfoTooltip = ({content}) => {
    return (
        <div style={tooltipStyles}>
            <TooltipHost content={content} closeDelay={500} >
                <Icon iconName='info' />
            </TooltipHost>
        </div>
    )
}

const tooltipStyles = {
    verticalAlign: 'middle',
    display: 'inline-block',
    marginLeft: '5px',
    cursor: 'pointer',
    height: '16px',
    lineHeight: '16px'
};

export default InfoTooltip


// WEBPACK FOOTER //
// ./src/components/formFields/InfoTooltip.js